import { ActionTree, GetterTree, MutationTree } from "vuex";
import { ChatStoreType } from "@/types/ChatTypes";

const state: ChatStoreType = {
  token: "",
  expirationDate: "",
  whatsUri: process.env.VUE_APP_API_WHATSAPP,
};

const getters: GetterTree<ChatStoreType, any> = {
  chatToken: (st) => st.token,
  expirationDate: (st) => st.expirationDate,
  whatsUri: (st) => st.whatsUri,
};

const mutations: MutationTree<ChatStoreType> = {
  setChatData(st: ChatStoreType, { expirationDate, token }) {
    st.token = token;
    st.expirationDate = expirationDate;
  },
};

const actions: ActionTree<ChatStoreType, any> = {
  setChatData({ commit }, data) {
    commit("setChatData", data);
  },
  setChatUri({ commit }, chatUri) {
    commit("setChatUri", chatUri);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
